
import React, { useState, useEffect } from "react";
import { PencilSquareIcon, } from "@heroicons/react/16/solid";
import UpdateDepartForm from "./updateModal";
import { getRequest } from "../../utils/APICall";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { getAllDeptStart, getAllDeptSuccess } from "../../redux/deptSlice";
import moment from "moment";

const DepartTable = () => {
  const T_Head = [
    // "Department ID",
    "Department Title",
    "Time In",
    "Time Out",
    "Sick Leaves",
    "Casual Leaves",
    "Action",
  ];

  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [singleDeptData, setSingleDeptData] = useState([]);
  const { allDept, isLoader } = useSelector((state) => state.dept);
  const dispatch = useDispatch();
  const showUpdateModal = async (data) => {
    setIsUpdateModalOpen(true);
    setSingleDeptData(data);
  };
  const updateModalCancel = () => setIsUpdateModalOpen(false);

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        dispatch(getAllDeptStart());
        const response = await getRequest("getAllDepartment");
        console.log("daprt response ", response);
        if (response?.success && Array.isArray(response.data)) {
          dispatch(getAllDeptSuccess(response.data));
        }
        else {
          dispatch(getAllDeptSuccess([]));
        }
      } catch (error) {
        dispatch(getAllDeptSuccess([]));
        console.error("Error fetching departments:", error);
      }
    };
    fetchDepartments();
  }, []);

  return (
    <div className="font-[sans-serif] overflow-x-auto">
      <table className="min-w-full bg-white dark:bg-darkgray">
        <thead className="bg-primaryPurple dark:bg-lightgrey whitespace-nowrap">
          <tr>
            {T_Head.map((item, index) => (
              <th
                className="p-4 text-left text-sm md:text-lg font-bold text-white"
                key={index}
              >
                {item}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="whitespace-nowrap">
          {isLoader ? (
            Array(10)
              .fill(0)
              .map((_, index) => (
                <tr key={index}>
                  {T_Head.map((_, colIndex) => (
                    <td
                      key={colIndex}
                      className="p-4 border-b border-gray-100 animate-pulse"
                    >
                      <div className="h-4 bg-gray-300 rounded w-full"></div>
                    </td>
                  ))}
                </tr>
              ))
          ) :
            allDept.length == 0 ? (
              <tr className="bg-gray-50 dark:bg-gray-800">
                <td colSpan={6}>
                  <div className="min-h-[200px] sm:min-h-[300px] lg:min-h-[400px]
                    flex flex-col items-center justify-center
                    text-center gap-2">
                    <p className="animate-pulse text-sm sm:text-base font-medium text-gray-800 dark:text-white">
                      Department data is currently unavailable
                    </p>
                    <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">
                      Please check back later or try refreshing.
                    </p>
                  </div>
                </td>
              </tr>
            ) :
              (
                allDept?.length > 0 && allDept?.map((item, index) => (
                  <tr className="even:bg-blue-50 dark:even:bg-gray-700 dark:bg-gray-800 text-black dark:text-white" key={index}>
                    {/* <td className="p-4 text-sm text-black">{item.CODE}</td> */}
                    <td className="p-4 text-sm ">{item.TITLE}</td>
                    <td className="p-4 text-sm ">
                      {item.TIMEIN}
                    </td>
                    <td className="p-4 text-sm ">
                      {item.TIMEOUT}
                    </td>
                    <td className="p-4 text-sm ">{item.SICKLEAVES}</td>
                    <td className="p-4 text-sm ">{item.CASUALLEAVES}</td>
                    <td className="p-4">
                      <button
                        className="mr-4"
                        onClick={() => showUpdateModal(item)}
                        title="Edit"
                      >
                        <PencilSquareIcon className="h-6 w-6 text-blue-500" />
                      </button>
                    </td>
                  </tr>
                ))
              )}
        </tbody>
      </table>
      <UpdateDepartForm
        visible={isUpdateModalOpen}
        onClose={updateModalCancel}
        singleData={singleDeptData}
      />
    </div>
  );
};

export default DepartTable;
